import React, { Component } from 'react';
import {Modal, Button, ButtonToolbar} from 'reactstrap';
import { Field, reduxForm, clearFields } from 'redux-form';
import renderSelectField from '../../../../../../shared/components/form/Select';
import { withTranslation } from "react-i18next";

class MoveArticleToBlogModal extends Component {

    constructor() {
        super();
        this.state = {
            selectedBlog: null,
            selectedCategory: null
        }
    }

    render() {
        const {t, isOpen, onClose, onSubmit, blogs} = this.props;
        return (
            <Modal isOpen={isOpen} >
                <div className="form">
                    <div className="form form--horizontal">
                        <div className="form__form-group">
                            <span className="form__form-group-label">{t('modals.move_article.select_target_blog.label')}</span>
                            <div className="form__form-group-field">
                                <Field
                                    name="blog"
                                    component={renderSelectField}
                                    type="text"
                                    options={!blogs ? [] : blogs.map(blog => ({
                                        value: blog._id,
                                        label: blog.title
                                    }))}
                                    onChange={(option) => {
                                        if (this.state.selectedBlog && this.state.selectedBlog._id !== option.value) {
                                            this.props.dispatch(clearFields('move-post-to-blog', false, false, 'category'));
                                            this.setState({selectedCategory: null});
                                        }
                                        this.setState({selectedBlog: blogs.find(b => b._id === option.value)});
                                    }}
                                    placeholder={t('modals.move_article.select_target_blog.placeholder')}
                                />
                            </div>
                        </div>
                        <div className="form__form-group">
                            <span className="form__form-group-label">{t('modals.move_article.select_category.label')}</span>
                            <div className="form__form-group-field">
                                <Field
                                    name="category"
                                    component={renderSelectField}
                                    type="text"
                                    options={!this.state.selectedBlog ? [] : this.state.selectedBlog.categories.map(category => ({
                                        value: category._id,
                                        label: category.name
                                    }))}
                                    onChange={(option) => {
                                        this.setState({selectedCategory: option.value})
                                    }}
                                    placeholder={t('modals.move_article.select_category.placeholder')}
                                />
                            </div>
                        </div>
                    </div>

                    <ButtonToolbar className="form__button-toolbar">
                        <Button type="button" onClick={onClose}>{t('modals.move_article.buttons.cancel')}</Button>
                        <Button color="primary" disabled={!(this.state.selectedBlog && this.state.selectedCategory)} type="submit" onClick={() => {
                            return onSubmit(this.state.selectedBlog._id, this.state.selectedCategory)
                        }}>{t('modals.move_article.buttons.ok')}</Button>
                    </ButtonToolbar>

                </div>
            </Modal>
        )
    }
}

export default reduxForm({form: 'move-post-to-blog'})(withTranslation('dashboard')(MoveArticleToBlogModal));
